import { DateISO, Pagination, Success } from 'api/interfaces';
import { del, get, put } from 'api/methods';
import {
  AssemblyEventValue,
  AssemblyModalities,
  AssemblyType,
  SituationValues,
} from 'helpers/enums/Assembleia';
import { StatusMensagens } from 'helpers/enums/AssembleiaStatus';
import {
  getMergedParamsFromObject,
  toRequest,
} from 'helpers/utils/RequestUtils';
import { getAssembleiasAssessorBffEndpoint } from 'library/Apis';
import ApiService from 'services/ApiService';

export interface Nucleo {
  nucleo: string;
}

export interface Agencia {
  agencia: string;
  nucleos: Array<Nucleo>;
}

type ListaAgenciaResponse = Array<Agencia>;

interface UrlRequest {
  idEvento: number;
  urlTransmissao: string;
}

export interface PresencasResponse {
  contasCapital: number;
  presentes: number;
  convidados: number;
  presentesAptos: number;
  quorumAtingido: boolean;
  quantidadePessoasOnline: number;
}

export interface TipoPautaResponse {
  name: string;
  value: number;
}

interface ComissaoEleitoralMembro {
  nomeAssociado: string;
}

export type ComissaoEleitoral = Array<ComissaoEleitoralMembro>;

export interface ListaEventoElement {
  id: number;
  codigoCooperativa: string;
  titulo: string;
  tipo: AssemblyType;
  modo: AssemblyModalities;
  status: SituationValues;
  inicio: DateISO;
  fim: DateISO;
  flagPesquisa: boolean;
  flagEventoTeste: boolean;
}

export type ListaEventoResponse = Pagination<ListaEventoElement>;

export interface ListaEventoRequest {
  idEvento: number | Number[] | undefined;
  tiposEventos: String[];
  modalidades: String[];
  tipo: AssemblyEventValue;
  cooperativas: String[] | undefined;
  status: String[];
  dataFinal: DateISO;
  dataInicial: DateISO;
  page: number;
  size: number;
}

interface ResultadoParcialItemPauta {
  abstencao: boolean;
  descricao: string;
  idItemPauta: number;
  percentual: number;
  votos: number;
}

export interface AcompanharVotacao {
  itens: Array<ResultadoParcialItemPauta>;
  descricao: string | null;
  titulo: string;
}

const evento = {
  listar: (request: Partial<ListaEventoRequest>) => {
    const url = `${getAssembleiasAssessorBffEndpoint('1')}event/search`;
    return toRequest(ApiService.post, [url, request], 'getAllEvent');
  },
  mensagens: (idEvento: number, status: StatusMensagens) => {
    return put<Success>('assembleiasAssessor', 'evento/status-mensagens', {
      idEvento,
      status,
    });
  },
  evento: {
    bloquear: (idEvento: number) => {
      return put<Success>(
        'assembleiasAssessor',
        `evento/bloquear-evento/${idEvento}`
      );
    },
    trocarVideo: (data: UrlRequest) => {
      return put('assembleiasAssessor', 'evento/url', data);
    },
    excluir: (idEvento: number) => {
      return del('assembleiasAssessor', `evento/${idEvento}`);
    },
  },
  listarAgencias: (idEvento: number) => {
    return get<ListaAgenciaResponse>(
      'assembleiasAssessor',
      `evento/lista-agencias/${idEvento}`
    );
  },

  getEventBranches: (eventId: number) => {
    return get<ListaAgenciaResponse>(
      'assembleiasAssessorBff',
      `event/branches/${eventId}`
    );
  },

  atualizarPresencas: (idEvento: number) => {
    return get<PresencasResponse>(
      'assembleiasAssessor',
      `evento/presencas/${idEvento}`
    );
  },

  configs: (idEvento: number) => {
    return get<TipoPautaResponse[]>(
      'assembleiasAssessor',
      `pauta/configuracao?eventId=${idEvento}`
    );
  },
  searchMember: (SearchProps: {
    cooperative: number | string;
    text: string;
  }) => {
    return get<TipoPautaResponse[]>(
      'assembleiasAssessor',
      `pauta/pesquisar/candidato?${getMergedParamsFromObject(SearchProps)}`
    );
  },

  searchElectionCommissions: (SearchElectionCommissionsProps: {
    cooperative: string;
    idsBlocked?: String[];
    text: string;
  }) => {
    return get<TipoPautaResponse[]>(
      'assembleiasAssessor',
      `pauta/pesquisar/comissao-eleitoral?${getMergedParamsFromObject(
        SearchElectionCommissionsProps
      )}`
    );
  },
  listarComissaoEleitoral: (idEvento: number) => {
    return get<ComissaoEleitoral>(
      'assembleiasAssessor',
      `evento/comissao-eleitoral/${idEvento}`
    );
  },
  acompanharVotacao: (idPauta: number) => {
    return get<AcompanharVotacao>(
      'assembleiasAssessor',
      `resposta-pauta/parcial/${idPauta}`
    );
  },
  respostaPadrao: (codCoop: string) => {
    return get<AcompanharVotacao>(
      'assembleiasAssessor',
      `resposta-padrao/listar/${codCoop}`
    );
  },
};

export default evento;
